import { FC } from 'react';
import { ConnectorSetting } from './ConnectorSetting/ConnectorSetting';

export const ConnectorSettingPage: FC = () => {
  return <ConnectorSetting />;
};
